import {guideQueryOptions} from '@blesk-frontend/api';
import {createFileRoute} from '@tanstack/react-router';
import {GuideEditPage} from '@/features/guides';

export const Route = createFileRoute('/_app/guides/$guideId/edit')({
  validateSearch: (search: {new?: boolean; discountId?: string}) => {
    return search;
  },
  beforeLoad: ({context: {queryClient}, params: {guideId}}) => ({
    getTitle: () => {
      const guide = queryClient.getQueryData(guideQueryOptions(guideId).queryKey);
      return guide?.name || 'Редактор';
    },
  }),
  component: () => <GuideEditPage />,
});
